import { QueryDto } from '@routellers/types/dist/shared/query.dto';
import { QueryRO } from '@routellers/types/dist/shared/query.ro';
import { TranslationRO } from '@routellers/types/dist/translation/translation.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = QueryDto;

type ResponseData = QueryRO<TranslationRO>;

export const query: ApiMethodDeclaration<ParamsData, ResponseData> = (params) => ({
    url: '/translations',
    method: 'GET',
    params,
});
